import { addHours, addMinutes } from "date-fns";

import { EventType, PublicEvent } from "@classview/shared-types";

import {
  EventSchema,
  EventVisibility as FormEventVisibility,
} from "../types/manage-event.schema";

export function convertApiDataToFormData(
  data?: PublicEvent,
): NonNullable<EventSchema> {
  if (!data) {
    return {
      type: EventType.WORKSHOP,
      category: "",
      isScheduledToRecord: false,
      isFree: true,
      isApprovalRequired: false,
      isCapacityCapped: false,
      visibility: FormEventVisibility.PRIVATE,
      // TODO: This is a temporary solution until I figure out how to handle the two states of a form type
      startTime: addMinutes(new Date(), 5 - (new Date().getMinutes() % 5)),
      endTime: addMinutes(
        addHours(new Date(), 1),
        5 - (new Date().getMinutes() % 5),
      ),
      startDate: new Date(),
      name: "",
      bannerS3Path: "",
      description: "",
      isClosedCaptionsEnabled: false,
      isParticipantScreenSharing: false,
      isRaisedHandSoundEnabled: false,
      isChatEnabled: false,
    };
  }

  return {
    bannerS3Path: data.bannerS3Path,
    category: data.category,
    type: data.type,
    isCapacityCapped: data.isCapacityCapped,
    isFree: data.isFree,
    visibility: data.visibility as FormEventVisibility,
    isApprovalRequired: data.isApprovalRequired,
    ...(data.isCapacityCapped && {
      capacityLimit: data.capacityLimit,
    }),
    ...(!data.isFree && {
      cost: data.cost,
    }),
    startTime: new Date(data.session.start),
    endTime: new Date(data.session.end),
    startDate: new Date(data.session.start),
    isScheduledToRecord: data.session.isScheduledToRecord,
    name: data.session.name,
    description: data.session.description || "",
    isClosedCaptionsEnabled: data.session.isCCEnabled,
    isParticipantScreenSharing: data.session.isScreenSharingEnabled,
    isRaisedHandSoundEnabled: data.session.isRaisedHandSoundEnabled,
    isChatEnabled: data.session.isChatEnabled,
  };
}
